module.exports = {
  xs: 364,
  sm: 600,
  md: 780,
  lg: 1280,
  xl: 1920,
};
